// extracted by mini-css-extract-plugin
module.exports = {"link":"_8552c41","linkWrapper":"_58c8441","linkIcon":"_bd2b791","linkTitle":"_f033994","linkTitleName":"_1fe8289"};